import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./solar-systems.css";
import solar1 from "./img-domotic/solarsystem1.png"
import solar2 from "./img-domotic/solarsystem2.png"
import solar3 from "./img-domotic/solarsystem1.png"

import sunpower from "./img-domotic/solarsystem1.png"
import lg from "./img-domotic/solarsystem1.png"
import solaredge from "./img-domotic/solarsystem1.png"
import enphase from "./img-domotic/solarsystem1.png"

const SolarEnergy = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Energía Solar
  const imagenesGaleria = [
    { src: solar1, alt: "Instalación de paneles solares", caption: "Sistemas fotovoltaicos residenciales y comerciales" },
    { src: solar2, alt: "Instalación profesional", caption: "Técnicos certificados en implementación" },
  ];

  const servicios = [
    {
      icon: "☀️",
      titulo: "Paneles Solares",
      descripcion: "Instalación de sistemas fotovoltaicos con tecnología de última generación.",
      features: ["Monocristalinos/Policristalinos", "Garantías de 25+ años", "Eficiencia >22%"]
    },
    {
      icon: "🔋",
      titulo: "Almacenamiento",
      descripcion: "Sistemas de baterías para maximizar el autoconsumo y respaldo energético.",
      features: ["Baterías de litio", "Gestión inteligente", "Integración con red"]
    },
    {
      icon: "📱",
      titulo: "Monitoreo Inteligente",
      descripcion: "Plataformas para seguimiento en tiempo real del rendimiento del sistema.",
      features: ["App móvil", "Alertas de rendimiento", "Reportes de ahorro"]
    },
    {
      icon: "🏭",
      titulo: "Soluciones Industriales",
      descripcion: "Sistemas a gran escala con inversores centrales para alta demanda.",
      features: ["Plantas solares", "Huertos fotovoltaicos", "PPA (Power Purchase Agreements)"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Residencial",
      items: [
        "On-grid (conectado a red)",
        "Off-grid (autónomo)",
        "Sistemas híbridos",
        "Bombeo solar"
      ]
    },
    {
      categoria: "Comercial",
      items: [
        "Sistemas para retail",
        "Cubiertas solares",
        "Estacionamientos solares",
        "Naves industriales"
      ]
    },
    {
      categoria: "Componentes",
      items: [
        "Microinversores",
        "Optimizadores de potencia",
        "Estructuras de montaje",
        "Protecciones eléctricas"
      ]
    }
  ];

  const marcas = [
    { nombre: "SunPower", logo: sunpower },
    { nombre: "LG Solar", logo: lg },
    { nombre: "SolarEdge", logo: solaredge },
    { nombre: "Enphase", logo: enphase },
    { nombre: "Fronius", logo: "/marcas/fronius.png" },
    { nombre: "Huawei Solar", logo: "/marcas/huawei-solar.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.solar-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="solar-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="solar-hero">
        <div className="solar-hero-content">
          <h1 className="solar-hero-title">Sistemas de Energía Solar</h1>
          <p className="solar-hero-subtitle">
            Soluciones sostenibles para generación y almacenamiento de energía
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="solar-gallery solar-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="solar-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="solar-gallery-img"
            />
            <div className="solar-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

        {/* Sección de Características con Imágenes de Fondo */}
<section className="ryn-features-section">
  <div className="ryn-features-container">
    <h2 className="ryn-features-title">Lo mejor para tus soluciones de Energia Solar</h2>
    
    <div className="ryn-features-grid">
      {/* Característica 1 */}
      <div className="ryn-feature-card">
        <div className="ryn-feature-content">
          <h3 className="ryn-feature-title">Enegia Solar</h3>
          <ul className="ryn-feature-list">
            <li> Sistemas de energía fotovoltaica on grid, off grid e  híbridos  
            </li>
            <li>Elaboración de proyectos y diseño de soluciones 
            </li>
            <li>Luminarias LED  solares y con paneles solares y baterías </li>
           

          </ul>
        </div>
      </div>
     
    </div>
  </div>
</section>  




    </div>
  );
};

export default SolarEnergy;